<div id="app" class="authentication-layout">
	<section id="content">
		<div class="app-logo">
			<img priority ngSrc="/assets/images/logos/logo_aston_ai.png" [width]="200" [height]="47" alt="{{ 'App.Name' | translate }} - {{ 'App.Baseline' | translate }}">
		</div>

		<main id="main">
			<router-outlet />

		</main>
	</section>
</div>
